export default function Hero() {
  const stats = [
    { label: '每日更新', value: '全天候滚动', icon: 'ri-timer-flash-line' },
    { label: '覆盖平台', value: '30+主流平台', icon: 'ri-global-line' },
    { label: '编辑团队', value: '资深媒体人操刀', icon: 'ri-team-line' },
  ];

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-100 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span className="whitespace-nowrap">每日更新 · 一手瓜料</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              爆料网
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-1">
                网红圈每日八卦爆料聚合平台
              </span>
            </h1>

            <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-2xl lg:max-w-none mb-3">
              最新网红吃瓜黑料八卦，一网打尽。
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl lg:max-w-none mb-8">
              爆料网专注网红圈八卦娱乐资讯聚合，覆盖直播圈、短视频圈、娱乐圈、电竞圈等核心领域。
              我们以7×24小时全天候滚动更新的方式，追踪头部达人的最新动态、行业黑幕与八卦爆料，
              每日整理最热瓜料合集，让你不错过任何一个值得围观的话题。
              当前平台正重点追踪MCN机构内幕曝光、直播带货数据造假及网红人设崩塌三大主题系列。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="flex items-center gap-2 text-sm text-foreground-600">
                  <span className="w-6 h-6 flex items-center justify-center text-accent-500"><i className={`${s.icon} text-base`}></i></span>
                  <span className="text-foreground-400">{s.label}</span>
                  <span className="text-foreground-800 font-medium whitespace-nowrap">{s.value}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-movie-line"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 rounded-md font-medium text-sm hover:bg-background-200/50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20collage%20with%20warm%20vibrant%20orange%20and%20red%20tones%2C%20magazine%20layout%20aesthetic%2C%20breaking%20news%20visual%20with%20overlapping%20text%20blocks%20and%20geometric%20shapes%2C%20dramatic%20lighting%20on%20abstract%20silhouettes%2C%20entertainment%20media%20atmosphere%2C%20modern%20Chinese%20editorial%20design%2C%20warm%20cream%20background%20with%20coral%20accents%2C%20high%20contrast%20composition%2C%20professional%20newsroom%20vibe&width=700&height=500&seq=hero-baoliao-2026&orientation=landscape"
                alt="爆料网 - 网红八卦娱乐资讯聚合平台主视觉"
                className="w-full h-auto rounded-lg"
                width="700"
                height="500"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/50 to-transparent p-5">
                <p className="text-background-50 text-sm font-medium">最新网红吃瓜黑料八卦，每日更新一网打尽</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}